export const findTimetabledSession = (timetables=[]) => {
  const startedSession = timetables.find(t => t.state === 'started');

  if (startedSession) {
    return startedSession;
  }

  const firstUpcomingSession = timetables.find(t => t.state === 'upcoming');
  return firstUpcomingSession;
}
